module.exports = __webpack_public_path__ + "img/arrow-down.9e82ef45.svg";